(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    customElements.define('slideshow-inline', class extends Core {
        defaultProps = {
            gap: 20,
            slidesPerView: 4
        }

        elements = {
            swiper: '[data-swiper]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {
            this.swiperProps = {
                // slidesPerView: this.slidesPerView,
                // ,
                loop: this.withLoop,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    1: {
                        slidesPerView: 1.5,
                        spaceBetween: this.gap/1.5
                    },
                    992: {
                        slidesPerView: this.slidesPerView,
                        spaceBetween: this.gap
                    }
                }
            };
            if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
            }
        }

        get slidesPerView() {
            return this.getAttribute('slides-per-view') 
                && +this.getAttribute('slides-per-view') 
                || this.defaultProps.slidesPerView;
        }
        get slidesCount() {
            return this.getAttribute('slides-count');
        }
        get gap() {
            return this.getAttribute('gap') 
                && +this.getAttribute('gap') 
                || this.defaultProps.gap;
        }
        get withOffset() {
            return this.hasAttribute('offset');
        }
        get withLoop() {
            return this.hasAttribute('loop') && this.slidesCount > this.slidesPerView;
        }
        get slidesCount() {
            return Number(this.getAttribute('slides-count') || this.querySelectorAll('.swiper-slide').length);
        }
        get offset() {
            return (window.innerWidth - window.containerInnerWidth) / 2;
        }
    })
})();